import React from 'react'
import Link from 'next/link'
import { FormikErrors } from 'formik'

import Icon from 'components/Icon'
import ButtonAnchor from 'components/ButtonAnchor'

import { UserAttributesArguments } from '../../../../../__generated__/globalTypes'

import styles from './SignupUserForm.module.css'

type EmailAndPhoneTakenMessageProps = {
  loginPath?: string
  errors: FormikErrors<UserAttributesArguments>
}

const EmailAndPhoneTakenMessage = ({ loginPath, errors }: EmailAndPhoneTakenMessageProps) => {
  const { email, phone } = errors

  return (
    <div className={styles.emailTakenContainer}>
      <Icon kind="alert-circle" color={'var(--colorPrimaryDark)'} />
      <p>
        Your {email && 'email address'}
        {email && phone && ' and '}
        {phone && 'phone number'}
        {(email || phone) && ' '} is already in use for a Fieldfolio profile.
      </p>
      <Link href={loginPath ? loginPath : '/login'} passHref>
        <ButtonAnchor kind="primary">Login</ButtonAnchor>
      </Link>
      <p>
        You can signup again using a different {email && 'email address'}
        {email && phone && ' and '}
        {phone && 'phone number'} below
      </p>
    </div>
  )
}

export default EmailAndPhoneTakenMessage
